import { AccessActions, AccessInitialState } from "redux/actions/Access";

export const AccessReducer = (state = AccessInitialState, actions) => {
  switch (actions.type) {
    case AccessActions.ACCESS_UPDATE_SEP:
      return {
        ...state,
        access_update_sep: actions.payload,
      };

    case AccessActions.ACCESS_DELETE_SEP:
      return {
        ...state,
        access_delete_sep: actions.payload,
      };

    default:
      return state;
  }
};
